import React from "react";

const AboutUs = () => {
  return (
    <div>
      <div className="py-[3px]">
        <div className="rounded-t-[20px] w-full bg-rose-500 text-primary-content">
          <div className="card-body py-2 items-center text-center">
            <img className="w-[30px]" src="/culogo.png" alt="" />

            <h2 className="card-title text-white">About Us</h2>
          </div>
        </div>
      </div>

      <div className="card-body py-2 items-center text-center">
        <p>
          "cuFeeds" is web based application. Here you will get all important
          news updated. This app maintain by university staff.
        </p>

        <p>App Version : 1.0.0</p>
      </div>
    </div>
  );
};

export default AboutUs;
